import { BaseEntity } from "./BaseEntity";

export class StoreObjectCategory extends BaseEntity {   
    name: string = '';
    isVisible: boolean = false;
}